import { Droplets, FlaskConical, PackageCheck, ScanSearch } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const PILLARS = [
  { icon: Droplets, label: "Single Cold Pressed" },
  { icon: ScanSearch, label: "Fully Traceable" },
  { icon: PackageCheck, label: "Packed to Stay Fresh" },
  { icon: FlaskConical, label: "Lab Verified, Every Batch" },
];

const STORY = [
  {
    title: "Keeping It Real",
    text: "When the first thing in your buyer's pan is made right, everything after feels better. That's why we press and grade everything the slow, honest way — clean, traceable and fresh.",
  },
  {
    title: "What Goes In (& What Doesn't)",
    text: "No chemicals. No solvents. No blending. Just export-grade seeds, turmeric and chillies from farms we know by name — and skilled hands that have done this for generations.",
  },
  {
    title: "What Your Buyers Get",
    text: "Batch-coded lots with lab reports on request, packaging built for long sea voyages, and flavour so honest your customers will taste the difference in the first spoonful.",
  },
];

export default function CraftStandard() {
  return (
    <section id="craft" data-testid="craft-standard-section" className="bg-cream py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="text-center">
          <Eyebrow>The Tsugiva Standard</Eyebrow>
          <h2 className="mx-auto mt-3 max-w-2xl font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl lg:text-5xl">
            Made in-house. Packed fresh.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-6 lg:grid-cols-4">
          {PILLARS.map((p, i) => (
            <Reveal key={p.label} delay={i * 0.08}>
              <div data-testid={`craft-pillar-${p.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="group flex flex-col items-center text-center">
                <span className="flex h-24 w-24 items-center justify-center rounded-full border-2 border-gold/30 bg-white text-gold shadow-[0_16px_40px_-16px_rgba(212,139,22,0.4)] transition-all duration-500 group-hover:scale-105 group-hover:border-gold group-hover:bg-gold group-hover:text-white">
                  <p.icon size={34} strokeWidth={1.6} />
                </span>
                <span className="mt-4 font-serif text-base font-semibold text-ink sm:text-lg">{p.label}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid gap-5 md:grid-cols-3">
          {STORY.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1} className="h-full">
              <div className="h-full rounded-2xl border border-stone2 bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold hover:shadow-[0_20px_50px_-18px_rgba(212,139,22,0.3)]">
                <h3 className="font-serif text-xl font-semibold text-ink">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-smoke">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
